import {ApplicationRef, Injectable} from '@angular/core';
import {StateService} from 'src/app/core/services/state/state.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';
// import {IMyOptions} from 'mydatepicker';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import {ContentSearchFilters} from 'src/app/shared/classes/services/content_search_filters';
import {JobsListService} from './jobs-list.service';

@Injectable({
    providedIn: 'root'
})
export class JobsSearchFiltersService extends ContentSearchFilters {

    public preferences: boolean;
    public filter: boolean;

    public datePickerOptions: any = {dateFormat: 'dd/mm/yyyy'};
    public dateStart: any;
    public dateEnd: any;
    public dateStartModel = {};
    public dateEndModel = {};
    public hiringDateModel = {};

    public testsOptions: any;
    public optionsTestsModel: any = [];

    public dropDownSettings: IDropdownSettings = {
        idField: 'id',
        textField: 'name',
        itemsShowLimit: 1,
        enableCheckAll: false
    };

    public subAccountsOptions = [];
    public subAccountsOptionsModel: any = [];

    public departmentOptions = [];
    public departmentOptionsModel: any = [];

    public testStatuses: any = {};
    public optionsTestsStatusModel = [];
    public optionsTestsStatusRaModel = [];

    public testsStatusOptions: any;

    public checkedColumn: any = [];

    public sortCardsBy = '';
    public sortCardsOrder = 'asc';

    constructor(
        public stateService: StateService,
        protected router: Router,
        protected applicationRef: ApplicationRef,
        protected deviceService: DeviceDetectorService,
        public jobsList: JobsListService
    ) {
        super(stateService, router, applicationRef, deviceService);
    }

    initInputState() {
        if (this.stateService[this.jobsList.specificState].listSearchFilters) {
            // Sub-accounts
            if (this.stateService[this.jobsList.specificState].listSearchFilters.subAccount) {
                let subAccArr = this.stateService[this.jobsList.specificState].listSearchFilters.subAccount;
                if (typeof this.stateService[this.jobsList.specificState].listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }
                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }
            // Departments
            this.setDepartmentsModel(this.stateService[this.jobsList.specificState]);
        }

        let colSelected = 0;
        for (let col of this.columns) {
            if (this.filtering(this.listColumns, col)) {
                colSelected++;
            }
        }
    }

    initInputStatePreferences(obj) {
        // override these with user preferences
        if (obj.userPreferences && obj.userPreferences.jobs) {
            for (let col in obj.userPreferences.jobs.display) {
                if (obj.userPreferences.jobs.display.hasOwnProperty(col)) {
                    let index = 0;
                    for (let o of this.listColumns) {
                        if (o.key === obj.userPreferencesService.plusToDot(col)) {
                            if (this.listColumns[index]) {
                                this.listColumns[index].display = obj.userPreferences.jobs.display[col];
                            }
                        } else {
                        }
                        index++;
                    }
                }
            }
        }
        if (this.stateService[this.jobsList.specificState].listSearchFilters) {
            // Sub-accounts
            this.subAccountsOptionsModel = [];
            if (this.stateService[this.jobsList.specificState].listSearchFilters.subAccount) {
                let subAccArr = this.stateService[this.jobsList.specificState].listSearchFilters.subAccount;
                if (typeof this.stateService[this.jobsList.specificState].listSearchFilters.subAccount === 'string') {
                    subAccArr = subAccArr.split(',');
                }

                this.subAccountsOptionsModel = subAccArr
                    .map(function (item) {
                        return parseInt(item, 10);
                    });
            }
            // Departments
            this.setDepartmentsModel(this.stateService[this.jobsList.specificState]);
            if (obj && obj.changeDetectorRef) {
                obj.changeDetectorRef.markForCheck();
            }
        }
    }

    get columns() {
        return this.jobsList.columns;
    }

    get listColumns() {
        return this.jobsList.listColumns;
    }
}
